import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["iconName"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useTheme } from "@emotion/react";
import React, { useContext, useEffect, useRef, useState } from "react";
import { getBoxPaddings, isEmpty, safeMerge } from "../../common/utilities";
import { ThemeProviderContext } from "../../ThemeProvider/ThemeProviderContext";
import { getIcon } from "../../themes/common/utilities";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export default function (_ref) {
  var _theme$components;

  let {
    iconName
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  const theme = useTheme();
  const svgicon = theme === null || theme === void 0 ? void 0 : (_theme$components = theme.components) === null || _theme$components === void 0 ? void 0 : _theme$components.svgicon;
  const [iconReady, setIconReady] = useState(false);
  const iconRef = useRef();
  const isMountedRef = useRef(false);
  const context = useContext(ThemeProviderContext) || null;
  const preloadStylesSvgRef = useRef({
    display: "inline-block",
    width: otherProps === null || otherProps === void 0 ? void 0 : otherProps.width,
    height: otherProps === null || otherProps === void 0 ? void 0 : otherProps.height
  });
  const preloadStylesSpanRef = useRef({
    display: "inline-block",
    height: "100%"
  });

  if (!otherProps || isEmpty(otherProps)) {
    otherProps.size = "medium";
  } else {
    if (typeof otherProps.size === "string") {
      var _svgicon$svg;

      const size = svgicon === null || svgicon === void 0 ? void 0 : (_svgicon$svg = svgicon.svg) === null || _svgicon$svg === void 0 ? void 0 : _svgicon$svg.defaultSizes[otherProps.size];
      preloadStylesSvgRef.current.width = size;
      preloadStylesSvgRef.current.height = size;
    }

    if (otherProps.spacing) {
      preloadStylesSpanRef.current = safeMerge(preloadStylesSpanRef.current, getBoxPaddings(otherProps.spacing));
    }
  }
  /**
   * This helps if the component mounts and unmounts before the
   * icon is actually asynchronously loaded. When the Component
   * unmounts, it marks this ref as false. Since this ref is checked
   * in the asynchronous useEffect, just before calling
   * `setIconReady(true)`, it makes sure that the component is not
   * marking itself ready when it's actually being unmounted.
   */


  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  /**
   * Asynchronously loading the icon based on the current theme.
   * If the theme is unknown, or if the component is not mounted,
   * nothing happens.
   */

  useEffect(() => {
    (async () => {
      if (context && context.baseTheme && isMountedRef.current) {
        try {
          iconRef.current = await getIcon(iconName, context.baseTheme);
          /* istanbul ignore else */

          if (iconRef.current && isMountedRef.current) {
            setIconReady(true);
          }
        } catch (error) {// nothing to declare officer
        }
      }
    })();
  }, [context, iconName]);
  return _jsx(React.Fragment, {
    children: iconReady ? _jsx(iconRef.current, _objectSpread({}, otherProps)) : _jsx("span", {
      style: _objectSpread({}, preloadStylesSpanRef.current),
      children: _jsx("span", {
        style: _objectSpread({}, preloadStylesSvgRef.current)
      })
    })
  });
}